// Mock data for Looking4 recruitment website
// This data is FRONTEND-ONLY for now and will be replaced by backend APIs later.

export const NAV_LINKS = [
  { label: "Accueil", to: "hero" },
  { label: "Entreprise", to: "expertise" },
  { label: "Candidat", to: "jobs" },
  { label: "Looking4", to: "why" },
  { label: "Contact", to: "contact" },
];

export const HERO = {
  badge: "BRETAGNE & PAYS DE LA LOIRE",
  title: "Vos Recrutements Méritent Mieux Qu'une Pile De CVs",
  description:
    "Looking4 vous accompagne dans la définition de votre besoin en recrutement, en préqualifiant les profils issus de notre recherche par approche directe et en exploitant notre vivier de candidats actifs.",
  location: "Bretagne & Pays de la Loire · PME, ETI, Groupes",
  card: {
    title: "Recrutements profils industriels",
    subtitle:
      "R&D, Maintenance, Production, Supply Chain, Technico-commercial, Informatique industrielle",
  },
};

export const HERO_STATS = [
  { value: "5/5", label: "Avis clients Google", stars: true },
  { value: "21 j", label: "délai moyen" },
];

export const CLIENTS = [
  "INTERROLL",
  "SSI SCHÄFER",
  "ASERTI",
  "BARILLA",
  "EVADEA",
  "LES ŒUFS GESLIN",
  "VISION PLAST",
];

export const KEY_STATS = [
  { value: "3 sem.", label: "Délai moyen recrutement" },
  { value: "100%", label: "CDI" },
];

export const EXPERTISE = {
  kicker: "NOTRE EXPERTISE",
  title: "Recrutements Industriels",
  paragraphs: [
    "Looking4 est un cabinet de recrutement spécialisé dans les métiers de l'industrie. L'industrie évolue en permanence. Entre la pénurie de compétences, les départs à la retraite, l'augmentation des exigences techniques et le besoin de performance opérationnelle, recruter est devenu un véritable enjeu stratégique.",
    "C'est dans ce contexte que Looking4 est né !",
    "L'objectif est simple : aider les entreprises industrielles à recruter les bonnes personnes. Production, maintenance, méthodes, supply chain, qualité, direction industrielle… nous connaissons les réalités du terrain.",
    "Nous ne prétendons pas réinventer le recrutement. Nous aidons simplement ceux qui font fonctionner l'industrie à s'entourer des bonnes personnes.",
  ],
  metiersTitle: "Métiers",
  metiersSubtitle:
    "Techniciens, ingénieurs R&D, managers de production, profils commerciaux",
  metiers: [
    "Maintenance industrielle",
    "Responsable production",
    "Ingénieur automatisme",
    "QHSE / HSE",
    "Chef de projet industriel",
    "Acheteur industriel",
    "Ingénieur d'affaires",
    "R&D - Méthodes",
    "Informatique industrielle",
  ],
};

export const PROCESS = {
  kicker: "NOTRE PROCESS",
  title: "Un Recrutement Sans Friction,",
  subtitle: "De La Définition Du Besoin Au Suivi Post Recrutement",
  steps: [
    {
      n: "1",
      title: "Brief & Cadrage",
      text: "Nous analysons votre besoin en profondeur : compétences techniques, culture d'entreprise, contexte et enjeux du poste.",
    },
    {
      n: "2",
      title: "Chasse & Qualification",
      text: "Approche directe sur les candidats passifs, évaluation technique et comportementale, shortlist de 3 à 5 profils validés.",
    },
    {
      n: "3",
      title: "Placement & Suivi",
      text: "Coordination des entretiens, accompagnement à la négociation, suivi post-intégration pour garantir la durabilité.",
    },
  ],
};

export const WHY = {
  kicker: "POURQUOI LOOKING4",
  title: "Ce qui nous différencie",
  items: [
    {
      icon: "Zap",
      title: "Rapidité D'exécution",
      text: "Grâce à notre vivier de candidats actifs et passifs, nous identifions les bons profils en moins de 72h après le brief.",
    },
    {
      icon: "Target",
      title: "Approche Directe... Mais Pas Que",
      text: "Notre force, c'est l'approche directe : nous allons chercher les candidats là où ils sont, dans les entreprises concurrentes, les réseaux pros et les communautés métier. Mais nous ne nous limitons pas à cela : nous sommes également présents sur les principaux jobboards pour maximiser votre visibilité et capter tous les bons profils.",
    },
    {
      icon: "Microscope",
      title: "Validation Technique",
      text: "Chaque candidat est évalué techniquement sur les compétences clés du poste avant d'être présenté. Vous ne recevez que des profils qualifiés.",
    },
    {
      icon: "BarChart3",
      title: "Suivi En Temps Réel",
      text: "Accès à un tableau de bord pour suivre l'avancement de votre recrutement à chaque étape, sans avoir à relancer votre consultant.",
    },
    {
      icon: "Handshake",
      title: "Engagement Humain",
      text: "Un consultant dédié qui connaît votre secteur, votre entreprise et vos standards. Pas de changement d'interlocuteur en cours de mission.",
    },
    {
      icon: "ShieldCheck",
      title: "Garantie De Remplacement",
      text: "Si le candidat placé quitte l'entreprise dans les 3 mois suivant son intégration, nous relançons la mission sans frais supplémentaires.",
    },
  ],
};

export const JOBS = [
  {
    id: "j1",
    title: "Responsable Maintenance Industrielle",
    location: "Nantes (44)",
    contract: "CDI",
    salary: "45 - 55 K€",
    domain: "Maintenance",
    description:
      "Pilotez une équipe de techniciens et garantissez la disponibilité de l'outil de production sur un site agroalimentaire de premier plan.",
    tags: ["GMAO", "Management", "Préventif"],
  },
  {
    id: "j2",
    title: "Ingénieur Automatisme",
    location: "Rennes (35)",
    contract: "CDI",
    salary: "40 - 50 K€",
    domain: "R&D",
    description:
      "Concevez et déployez des architectures d'automatisme pour des lignes de production nouvelle génération. Environnement Siemens / Schneider.",
    tags: ["TIA Portal", "Robotique", "SCADA"],
  },
  {
    id: "j3",
    title: "Responsable de Production",
    location: "Vannes (56)",
    contract: "CDI",
    salary: "50 - 60 K€",
    domain: "Production",
    description:
      "Animez les équipes de production, pilotez les indicateurs de performance et menez les chantiers d'amélioration continue (Lean).",
    tags: ["Lean", "SQCDP", "5S"],
  },
  {
    id: "j4",
    title: "Ingénieur QHSE",
    location: "Angers (49)",
    contract: "CDI",
    salary: "38 - 46 K€",
    domain: "QHSE",
    description:
      "Déployez la politique qualité, sécurité et environnement sur site industriel. Pilotage des certifications ISO 9001 / 14001 / 45001.",
    tags: ["ISO 9001", "Audit", "Sécurité"],
  },
  {
    id: "j5",
    title: "Ingénieur d'Affaires Industriel",
    location: "Brest (29)",
    contract: "CDI",
    salary: "45 - 65 K€",
    domain: "Technico-commercial",
    description:
      "Développez un portefeuille de clients industriels, pilotez les projets techniques et négociez des contrats à forte valeur ajoutée.",
    tags: ["B2B", "Négociation", "Projets"],
  },
  {
    id: "j6",
    title: "Acheteur Industriel",
    location: "Le Mans (72)",
    contract: "CDI",
    salary: "40 - 48 K€",
    domain: "Supply Chain",
    description:
      "Gérez les achats de composants techniques, sourcez de nouveaux fournisseurs et optimisez les coûts sur un panel stratégique.",
    tags: ["Sourcing", "Négociation", "ERP"],
  },
];

export const FAQ_ITEMS = [
  {
    q: "Quels sont vos délais de recrutement ?",
    a: "Notre délai moyen est de 3 semaines entre le brief et la présentation d'une shortlist qualifiée. Grâce à notre vivier, nous identifions les premiers profils en moins de 72h.",
  },
  {
    q: "Dans quelles régions intervenez-vous ?",
    a: "Nous intervenons principalement en Bretagne et Pays de la Loire, au plus près des bassins industriels. Nous accompagnons également des missions ponctuelles au niveau national.",
  },
  {
    q: "Quelle est votre politique tarifaire ?",
    a: "Nous fonctionnons au succès : vous ne payez qu'une fois le candidat placé. Nos honoraires sont clairs, calculés sur la rémunération annuelle brute et convenus avant le lancement de la mission.",
  },
  {
    q: "Comment garantissez-vous la qualité des candidats présentés ?",
    a: "Chaque candidat est évalué techniquement et humainement sur les compétences clés du poste. Vous ne recevez qu'une shortlist de 3 à 5 profils réellement qualifiés et validés.",
  },
  {
    q: "Que se passe-t-il si le recrutement ne convient pas ?",
    a: "Nous offrons une garantie de remplacement : si le candidat placé quitte l'entreprise dans les 3 mois suivant son intégration, nous relançons la mission sans frais supplémentaires.",
  },
  {
    q: "Pourquoi passer par un cabinet de recrutement ?",
    a: "Pour gagner du temps, accéder à des candidats passifs invisibles sur les jobboards, et sécuriser vos recrutements stratégiques grâce à une évaluation experte des métiers de l'industrie.",
  },
];

export const FOOTER = {
  copyright:
    "Copyright © 2026 Looking4 | Recrutement Industrie & Tech en Bretagne et Pays de la Loire",
};
